import preloadImage from 'FileManagerCore/utils/preloadImage';
const preloadImagePromise = src => {
  return new Promise(resolve => {
    preloadImage(src, resolve);
  });
};
export default {
  preloadImagePromise
};